/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import { Button } from 'react-bootstrap';
import { MenuItem } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import RadioGroupComponent from '../../../SharedModules/RadioGroup/RadioGroupBtn';
import CheckBoxComponent from '../../../SharedModules/CheckBox/CheckBox';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import {
  setSelectedRebateProgram,
  getPlanType,
  getAssignDisputeDetail,
  storeErrorList,
  getRebateProgram,
  storeManufacturesList,
  updateFirstLoad,
} from './store/action';
import MaxLengthNumericEditor from '../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../SharedModules/StyleConstant/StyleConstant';
import TableGrid from '../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';
import * as Constants from '../../../SharedModules/AppConstants';
import * as ActionTypes from './store/actionTypes';
import { handleScrollToEvent } from '../../../SharedModules/CommonUtilities/commonUtilities';

const AssignDisputesSearch = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(true);
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [successMessages, setSuccessMessages] = React.useState([]);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [planType, setPlanType] = React.useState('');
  const [allManufacturers, setAllManufacturers] = React.useState(true);
  const [radioList, setRadioList] = React.useState([]);
  const [rebateProgram, setRebateProgram] = React.useState('All');
  const [check, setCheck] = React.useState(false);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [manufacturerTableData, setManufacturerTableData] = React.useState([]);
  const [singleManufacturer, setSingleManufacturer] = React.useState(null);
  const errorList = useSelector(
    (state) => state?.sharedState?.AssignDisputesSearchReducer?.errorList
  );
  const firstload = useSelector(
    (state) => state?.sharedState?.AssignDisputesSearchReducer?.firstload
  );
  const planTypeList = useSelector(
    (state) => state?.sharedState?.AssignDisputesSearchReducer?.planType
  );
  const selectedData = useSelector(
    (state) =>
      state?.sharedState?.AssignDisputesSearchReducer?.selectedRebateProgram
  );
  const rebatePrograms = useSelector(
    (state) =>
      state?.sharedState?.AssignDisputesSearchReducer?.rebateProgramList
  );
  const manufacturelist = useSelector(
    (state) => state?.sharedState?.AssignDisputesSearchReducer?.manufactureList
  );
  const disputeDetail = useSelector(
    (state) => state?.sharedState?.AssignDisputesSearchReducer?.disputeDetail
  );
  const checkFlag = useSelector(
    (state) => state?.sharedState?.AssignDisputesSearchReducer?.checkFlag
  );
  const rebateProgramCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.rebateProgramCd
  );
  const planTypeCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.planTypeCd
  );
  const rebatepgmDropdown = async (plan) => {
    const list = await dispatch(getRebateProgram(plan));
    setRebateProgramList(list);
  };

  React.useEffect(() => {
    if (planType !== '') rebatepgmDropdown(planType);
    else setPlanType('FD');
  }, [planType]);

  React.useEffect(() => {
    if (planTypeList) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name == 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      if (!firstload && planTypeCd && rebateProgramCd) {
        dispatch(
          setSelectedRebateProgram({
            plan: planTypeCd,
            rebateProgram: rebateProgramCd,
            allManufacturers: true,
            singleManufacturer: null,
          })
        );
        setPlanType(planTypeCd);
        dispatch(updateFirstLoad());
      } else if (!planType) setPlanType('FD');
    }
  }, [planTypeList]);
  React.useEffect(() => {
    dispatch(
      setSelectedRebateProgram({
        plan: planType,
        rebateProgram: rebateProgram,
        allManufacturers: allManufacturers,
        singleManufacturer: singleManufacturer,
      })
    );
    dispatch(getPlanType({ codeDomainList: ['PLAN_TYPE_CD'] }));
    handleScrollToEvent();
  }, []);

  React.useEffect(() => {
    // setRebateProgramList(rebatePrograms);
  }, [rebatePrograms]);

  React.useEffect(() => {
    setErrorMessages(errorList);
  }, [errorList]);
  React.useEffect(() => {
    setPlanType(selectedData?.plan);
    setRebateProgram(selectedData?.rebateProgram);
    setAllManufacturers(selectedData?.allManufacturers);
    setSingleManufacturer(selectedData?.singleManufacturer);
  }, [selectedData]);

  React.useEffect(() => {
    setLoading(false);
    setManufacturerTableData(manufacturelist);
  }, [manufacturelist]);

  const setManufacturerData = (plan, program, val) => {
    setSingleManufacturer(null);
    if (!val && plan && program && program !== '-1') {
      setLoading(true);
      dispatch(
        storeManufacturesList({ rebateProgramCD: program, planType: plan })
      );
    }
  };

  const tabHighLigher = (val) => {
    const data = JSON.parse(localStorage.getItem('tabItemsData'));
    const list = data.map((obj) => {
      if (obj.navTo === '/assignDisputesSearch') {
        obj.isFormError = val;
      }
      return obj;
    });
    localStorage.setItem('tabItemsData', JSON.stringify(list));
  };

  const onSearch = () => {
    dispatch(storeErrorList([]));
    if (rebateProgram === '-1') {
      dispatch(storeErrorList([Constants.REBATE_PGM_REQUIRED]));
      tabHighLigher(true);
    } else if (!allManufacturers && !singleManufacturer) {
      dispatch(storeErrorList([Constants.MANUFACTURER_EMPTY_MSG]));
      tabHighLigher(true);
      handleScrollToEvent();
    } else {
      getDetailsApiCall();
    }
  };

  const getDetailsApiCall = (data = null) => {
    tabHighLigher(false);
    dispatch({ type: 'CHECK_FLAG', payload: true });
    dispatch(
      setSelectedRebateProgram({
        plan: planType,
        rebateProgram: rebateProgram,
        allManufacturers: allManufacturers,
        singleManufacturer: singleManufacturer,
      })
    );
    const payload = {
      planType: planType,
      rebateProgramCD: rebateProgram,
    };
    if (data) {
      payload.mfgId = data.mfgId;
    } else if (!allManufacturers && singleManufacturer) {
      payload.mfgId = singleManufacturer.mfgId;
    }
    dispatch(getAssignDisputeDetail(payload, rebateProgramList));
    setLoading(true);
  };

  React.useEffect(() => {
    setCheck(checkFlag);
  }, [checkFlag]);
  React.useEffect(() => {
    setLoading(false);
    if (
      check &&
      disputeDetail?.data?.length > 0 &&
      !disputeDetail?.hasOwnProperty('dataEmpty')
    ) {
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      updateTabs.push({
        navTo: '/assignDisputesDetails',
        value: 'Assign Dispute Detail',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      props.history.push({
        pathname: '/assignDisputesDetails',
      });
      dispatch({ type: ActionTypes.ASSIGN_DISPUTE_DETAIL, payload: null });
    } else if (
      disputeDetail?.data?.length === 0 ||
      disputeDetail?.hasOwnProperty('dataEmpty')
    ) {
      dispatch(storeErrorList([Constants.SELECTION_NOT_MATCH]));
      tabHighLigher(true);
      // setTimeout(storeErrorList([]), 5000);
    }
  }, [disputeDetail]);

  const columnDefs = [
    {
      headerName: 'Manufacturer ID',
      field: 'mfgId',
      editable: false,
      sortable: true,
      suppressMenu: false,
      sort: 'asc',
      minWidth: Styles.Width_200,
      cellEditor: MaxLengthNumericEditor,
      sortingOrder: ['desc', 'asc'],
      cellStyle: { borderRightColor: Styles.BorderColor },
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
    {
      headerName: 'Manufacturer Name',
      field: 'mfgName',
      editable: false,
      sortable: true,
      resizable: false,
      suppressMenu: false,
      minWidth: Styles.Width_250,
      cellStyle: { borderRightColor: Styles.BorderColor },
      cellEditor: MaxLengthNumericEditor,
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
  ];

  const changeFullScreenView = (tableName) => {
    setFullScreenView(!fullScreenView);
  };

  const onSelectionChanged = useCallback((val) => {
    const selectedRows = val.api.getSelectedRows()[0];
    setSingleManufacturer(selectedRows);
    dispatch(storeErrorList([]));
    tabHighLigher(false);
  }, []);

  const cellClickedListener = (val) => {
    const selectedRows = val.api.getSelectedRows()[0];
    setSingleManufacturer(selectedRows);
    if (rebateProgram === '-1') {
      dispatch(storeErrorList([Constants.REBATE_PGM_REQUIRED]));
      tabHighLigher(true);
    } else {
      getDetailsApiCall(selectedRows);
      dispatch(storeErrorList([]));
      tabHighLigher(false);
    }
  };
  // hading On blur event on filed level
  const handleOnblurEvent = (type, value) => {
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        dispatch(storeErrorList([Constants.REBATE_PGM_REQUIRED]));
        tabHighLigher(true);
        dispatch(
          setSelectedRebateProgram({
            plan: planType,
            rebateProgram: value,
            allManufacturers: allManufacturers,
            singleManufacturer: null,
          })
        );
      } else {
        setManufacturerData(planType, value, allManufacturers);
        tabHighLigher(false);
        dispatch(storeErrorList([]));
        dispatch(
          setSelectedRebateProgram({
            plan: planType,
            rebateProgram: value,
            allManufacturers: allManufacturers,
            singleManufacturer: null,
          })
        );
      }
    }
  };

const [gridApi, setGridApi] = React.useState(null);


React.useEffect(() => {
  if (
    gridApi &&
    manufacturerTableData?.length > 0 &&
    !allManufacturers
  ) {
    gridApi.forEachNode((node) => {
      if (node.rowIndex === 0) {
        node.setSelected(true);

        setSingleManufacturer(node.data);
        dispatch(storeErrorList([]));
      }
    });
  }
}, [gridApi, manufacturerTableData, allManufacturers]);

  return (
    <div className="tabs-container" data-testid="AssignDisputesSearch">
      <Spinner load={loading} />
      <CustomSeparator parent1="Tasks" parent2="Assign Disputes Search" />
      <DisplaySuccessMessages successMessages={successMessages} />
      <DisplayErrorMessages errorMessages={errorMessages || []} />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-12 col-sm-6 col-md-5 frr-two-col-radio">
                <RadioGroupComponent
                  labelName="Plan Type"
                  optionList={radioList || []}
                  defaultValue={planType}
                  data-testid="planTypefilter"
                  required
                  reqColor
                  filterAction={(e) => {
                    setManufacturerData(e, 'All', allManufacturers);
                    dispatch(storeErrorList([]));
                    dispatch(
                      setSelectedRebateProgram({
                        plan: e,
                        rebateProgram: 'All',
                        allManufacturers: allManufacturers,
                        singleManufacturer: null,
                      })
                    );
                  }}
                />
              </div>
              <div className="col-12 mt-3 mt-sm-0 col-sm-6 col-md-4">
                <div className="mui-custom-form with-select">
                  <TextField
                    data-testid="rebate_program-ia"
                    id="rebate_program"
                    label="Rebate Program"
                    fullWidth
                    select
                    required
                    placeholder=""
                    inputProps={{ maxLength: 11, id: 'rebate_program' }}
                    onBlur={(e) =>
                      handleOnblurEvent('rebateProgramCd', e.target.value)
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={rebateProgram}
                    onChange={(e) => {
                      dispatch(storeErrorList([]));
                      dispatch(
                        setSelectedRebateProgram({
                          plan: planType,
                          rebateProgram: e?.target?.value,
                          allManufacturers: allManufacturers,
                          singleManufacturer: null,
                        })
                      );
                    }}
                    className={
                      errorMessages?.length > 0
                        ? _.map(errorMessages, (l) =>
                            l?.includes('Rebate Program is')
                              ? 'mandate-fields'
                              : null
                          )
                        : null
                    }
                    helperText={
                      errorMessages?.length > 0
                        ? _.map(errorMessages, (l) =>
                            l?.includes('Rebate Program is') ? l : null
                          )
                        : null
                    }
                    error={
                      errorMessages?.length > 0
                        ? _.map(errorMessages, (l) =>
                            l?.includes('Rebate Program is') ? l : null
                          )
                        : null
                    }
                  >
                    <MenuItem
                      key=""
                      value="-1"
                      className="frr-dropdown-blank-item"
                    />

                    {rebateProgramList?.length > 0
                      ? rebateProgramList.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-3">
                <CheckBoxComponent
                  labelName="All Manufacturers"
                  defaultValue={allManufacturers}
                  data-testid="allmanufacturercheck"
                  filterAction={(e) => {
                    if (e) {
                      dispatch(storeErrorList([]));
                      tabHighLigher(false);
                    }
                    setManufacturerData(
                      planType,
                      rebateProgram,
                      !allManufacturers
                    );
                    dispatch(storeErrorList([]));
                    dispatch(
                      setSelectedRebateProgram({
                        plan: planType,
                        rebateProgram: rebateProgram,
                        allManufacturers: !allManufacturers,
                        singleManufacturer: e ? null : singleManufacturer,
                      })
                    );
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="btn-wrapper col-12">
                <Button
                  className="btn btn-success btn-search float-right"
                  data-testid="onSearchBtn"
                  onClick={onSearch}
                >
                  <SVGComponent iconName="Icon-search" />
                  Search
                </Button>
              </div>
            </div>
          </>
        )}
        {!allManufacturers && (
          <div className="row">
            <div className="col-12">
              <TableGrid
                rowSelection="single"
                data-testid="manufacture-grid"
                gridHeight={fullScreenView ? '70vh' : 400}
                rowData={manufacturerTableData}
                columnDefs={columnDefs}
                fileName="Assign disputes"
                 onGridReady={(params) => {
                setGridApi(params.api);
                }}
                onSelectionChanged={onSelectionChanged}
                navigateToNextCell={navigateToNextCell}
                tabToNextCell={tabToNextCell}
                enterMovesDown
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={changeFullScreenView}
                exportFile
                suppressCellFocus
                onCellFocused={onCellFocused}
                helpMessage={Constants.DOUBLE_CLICK_INFO}
                cellClickedListener={cellClickedListener}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default withRouter(AssignDisputesSearch);
